// Core Domain Search Module Definition

import { createPremiumModule, ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';

// Import extensions
import { domainInputStoreExtension } from './extensions/store';
import { CoreDomainSearchApiClientExtension } from './extensions/CoreDomainSearchApiClientExtension';
import { CoreDomainSearchBiEventsExtension } from './extensions/CoreDomainSearchBiEventsExtension';
import { urlRecoveryExtension } from './extensions/urlRecoveryExtension';
import { CoreDomainSearchBaseLayout } from '../layouts';
import { DomainSearchBar } from '../components/DomainSearchBar/DomainSearchBar';
import { CoreDomainSearchTranslationsExtension } from './extensions/CoreDomainSearchTranslationsExtension';
// Create the premium-fed module
export const CoreDomainSearchModule = createPremiumModule('coreDomainSearch', [
// Built-in Extensions
ModuleExtensions.dataHooksExtension(['domainSearchBar', 'searchInput', 'searchSubmitButton', 'tldSelector', 'keywordSelector', 'keywordMultiselect', 'styleSelector', 'clearFilters', 'styleDropdown', 'toolBar', 'errorDisplay', 'errorRetryButton', 'errorDismissButton', 'clearInput']), CoreDomainSearchTranslationsExtension, ModuleExtensions.customComponentsExtension(CoreDomainSearchBaseLayout, 'Layouts'),
// Custom Extensions (Following BrandProtection Pattern)
domainInputStoreExtension, CoreDomainSearchApiClientExtension, CoreDomainSearchBiEventsExtension, urlRecoveryExtension], () => ({
  SDK: {
    Components: {
      DomainSearchBar
    }
  }
}));

// Export backend for direct access
export const CoreDomainSearchBackend = CoreDomainSearchModule.internals.backend;
export const CoreDomainSearchDataHooks = CoreDomainSearchModule.internals.dataHooks;
//# sourceMappingURL=module.js.map